import { render, staticRenderFns } from "./nutrition-step-four.html?vue&type=template&id=7c5ad442&scoped=true&"
import script from "./nutrition-step-four.js?vue&type=script&lang=js&"
export * from "./nutrition-step-four.js?vue&type=script&lang=js&"
import style0 from "./nutrition-step-four.scss?vue&type=style&index=0&id=7c5ad442&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5ad442",
  null
  
)

export default component.exports